"use strict";
import {on, find, removeClass, addClass, findIn, findAllIn, closest, hasClass, removeAttribute, setAttribute} from "@elements/dom-utils";
import {visualizeCompleteness, setTabData, updateTab, unCompleteTab, completeTab} from "../tabManager";
import TerracePlanner from "../index";

export function init() {
    //register on all 'add' buttons in detail sections and also for the product items
    if (findAllIn('.js-planner__product-add', TerracePlanner.element)) {
        findAllIn('.js-planner__product-add', TerracePlanner.element).map((item) => {
            on('click', (evt) => productCompleteListener(evt, item), item);
        });
    }

    if (find('#stock-only')) {
        on('change', (evt) => stockOnlyListener(), find('#stock-only'));
    }

    if(TerracePlanner.tabConfig.product.complete) {
        updateProduct(TerracePlanner.tabConfig.product.productId);
        visualizeCompleteness('product');
    }
}

/**
 * switches the element marked as active
 *
 * @param productId
 */
function visualizeActiveProduct(productId) {
    if (findAllIn('.js-planner__product.is-selected', TerracePlanner.element)) {
        findAllIn('.js-planner__product.is-selected', TerracePlanner.element).map((selectedItem) => {
            removeClass('is-selected', selectedItem);
        });
    }

    if (findIn('.js-planner__product[data-product-id="' + productId + '"]', TerracePlanner.element)) {
        addClass('is-selected', findIn('.js-planner__product[data-product-id="' + productId + '"]', TerracePlanner.element));
    }
}

/**
 * collects data to update the tab with, sets tab data and completes the tab
 *
 * @param productId
 */
export function updateProduct(productId) {
    visualizeActiveProduct(productId);

    setTabData('product', {
        productId: productId
    });

    updateTab('product', findIn('.js-planner__product[data-product-id="'+ productId +'"] .js-planner__product-title', TerracePlanner.element).innerHTML.substr(0,45) + '...');
}

/**
 * listener to complete the tab via user interaction,
 * determines the selected product id and calls updateProduct
 *
 * @param evt
 * @param item
 */
function productCompleteListener(evt, item) {
    let productId = closest('.js-planner__product', item).getAttribute('data-product-id');
    updateProduct(productId);

    unCompleteTab('plankPattern');
    unCompleteTab('summary');
    completeTab('product', 'plankPattern');
}

/**
 * listener to invalidate the substructure tab if if the stock only checkbox is changed
 *
 * @param event
 */
function stockOnlyListener(event) {
    unCompleteTab('subStructure');
    unCompleteTab('plankPattern');
    unCompleteTab('summary');
}